import { useEffect, useState } from 'react';
import styled from 'styled-components';

import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import ClassSearch from '../../components/class/class/Search';
import ClassTable from '../../components/class/class/Table';
import ClassTopButtons from '../../components/class/class/TopButtons';
import ClassTab from '../../components/class/class/Tab';
import { useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { useTranslation } from 'react-i18next';
import useUtil from '../../hooks/useUtil';

const Block = styled.div`
  .close-left {
    transform: translate(-33%);
  }


  .table-inside {
    width: 100%;

    th {
      background: ghostwhite;
    }
  }

  .table-basic th, td {
    vertical-align: middle;
  }

  h5 {
    margin-left: 5px;
    margin-bottom: 0;
  }

  .arrow {
    font-size: 26px;
    line-height: 26px;
  }

  .date {
    display: inline-block;
    width: 130px;
  }

  .rbc-event {
    text-align: center;
  }
`;

const ClassClass = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isCampusDeactived } = useUtil();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const [isExtended, setIsExtended] = useState(false);
  const [tab, setTab] = useState('info');
  const [refreshTable, setRefreshTable] = useState(false);
  const [campusDeactived, setCampusDeactived] = useState(false);

  useEffect(() => {
    if (query.tab) {
      setTab(String(query.tab));
    }
  }, [location]);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
  }, [isCampusDeactived]);

  return (
    <Block className="content-wrapper">
      <Header
        parentMenu={t('common.menu.class')}
        currentMenu={t('class.class.title1')}
      />

      <div className={'main flex transition' + (isExtended ? ' close-left' : '')}>
        {/* Left Side */}
        <div className="col-4">
          <ClassSearch
            tab={tab}
          />
          <ClassTable
            refreshTable={refreshTable}
          />
        </div>

        {/* Right Side */}
        <div className={'transition ' + (isExtended ? 'col-12' : 'col-8')}>
          <ClassTopButtons
            isExtended={isExtended}
            setIsExtended={setIsExtended}
            setTab={setTab}
            campusDeactived={campusDeactived}
          />
          <ClassTab
            tab={tab}
            setTab={setTab}
            setIsExtended={setIsExtended}
            setRefreshTable={setRefreshTable}
          />
        </div>
      </div>
      <Footer />
    </Block>
  );
}

export default ClassClass;
